'use strict';

window.TeamUiShared = (function() {
  function openSheet(overlayId) {
    var overlay = document.getElementById(overlayId);
    if (overlay) overlay.classList.add('show');
  }

  function closeSheet(overlayId) {
    var overlay = document.getElementById(overlayId);
    if (overlay) overlay.classList.remove('show');
  }

  var toastTimer = null;
  function showToast(message, type) {
    var toast = document.getElementById('toast');
    var toastText = document.getElementById('toastText');
    if (!toast || !toastText) return;
    // 前回のクラスをリセット
    toast.classList.remove('is-warn');
    if (type === 'warn') {
      toast.classList.add('is-warn');
    }
    toastText.textContent = message;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function() {
      toast.classList.remove('show');
    }, 5200);
  }

  function hideToast() {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.classList.remove('show');
    clearTimeout(toastTimer);
  }

  function bindSheetDismiss() {
    $(document).on('click', '[data-close]', function() {
      var targetId = $(this).data('close');
      closeSheet(targetId);
    });
    $(document).on('click', '.sheet-overlay', function(e) {
      if (e.target === this) {
        this.classList.remove('show');
      }
    });
    $(document).on('click', '.toast-close', function() {
      hideToast();
    });
  }

  return {
    openSheet: openSheet,
    closeSheet: closeSheet,
    showToast: showToast,
    hideToast: hideToast,
    bindSheetDismiss: bindSheetDismiss
  };
})();

$(document).on('turbolinks:load', function() {
  TeamUiShared.bindSheetDismiss();
});
